import styled from 'styled-components';

import { CypressTestNamespace } from '@utils/test';

export const StyledGrid = styled.div.attrs(() => ({
  className: CypressTestNamespace.ECartPageServices.GIFT_PACKAGING_SERVICE_UNAVAILABLE,
}))`
  margin-top: 2rem;
  width: 100%;
  text-align: center;
`;

export const StyledTitle = styled.div`
  margin-top: 1rem;
  margin-bottom: 0.3125rem;
  font-weight: bold;
`;

export const StyledDescription = styled.div`
  margin-bottom: 1.3125rem;
`;
